export default __webpack_public_path__ + "static/news3-2cbec4d8083d7da8829344a0fa3a27be.jpg";